<template>
  <v-help ref="box" button="ok" :boxClass="$style.box" @click="$emit('click')" :className="$style.help" charHidden>
    <div :class="$style.inner" v-if="achievement">
      <div :class="$style.title">Ура, ты получил награду!</div>
      <div :class="$style.middle">
        <div :class="$style.img" :style="{ backgroundImage: `url(${achievement.img})` }"></div>
        <div :class="$style.name">{{achievement.title}}</div>
      </div>
      {{achievement.description}}
    </div>
  </v-help>
</template>
<script>
export default {
  name: 'achievementBox',
  data: () => ({
    achievement: null,
  }),
  methods: {
    open() {
      this.$refs.box.open()
    },
    close() {
      this.$refs.box.close()
    },
    async grant(id) {
      this.achievement = await this.$store.dispatch('setAchievement', id)
      this.open()
    },
  },
}
</script>
<style lang="scss" module>
.help {
  z-index: 9999999 !important;
}
.box {
  width: 48.9rem !important;
}
.inner {
  font-size: 1.6rem;
}

.title {
  font-size: 2.6rem;
  margin-bottom: 2rem;
}

.middle {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
}

.img {
  width: 12.1rem;
  height: 12.1rem;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  flex-shrink: 0;
  margin-right: 1rem;
}

.name {
  color: #23D1AE;
  font-size: 1.8rem;
}
</style>
